export interface DiscountData {
    key: string;
    productKey: string;
    stripePriceKey: string;
    code: string;
    price: number;
    title: string;
}
